__turbopack_context__.v({
  "authorImage": "dQh_FG_authorImage",
  "large": "dQh_FG_large",
  "medium": "dQh_FG_medium",
  "small": "dQh_FG_small",
});
